// Copyright (c) StrangeBee 2024

import { useContext } from 'react';
import { CollapseContext, CollapseContextInterface } from './context';

export const useCollapse = (): CollapseContextInterface => useContext(CollapseContext);
